import type { Printer } from "escpos-buffer";
import { useState } from "react";
import {
  authorisePrinter,
  getPreviousPrinter,
  havePreviousPrinter,
} from "./get-printer";

const useThermalPrinter = () => {
  const [printer, setPrinter] = useState<Printer>(null);
  const [error, setError] = useState<Error>(null);

  const getOrAuthorisePrinter = async () => {
    if (printer) return printer;
    try {
      let retrievedPrinter = await getPreviousPrinter();
      if (!retrievedPrinter) {
        retrievedPrinter = await authorisePrinter();
      }
      if (!retrievedPrinter) {
        setError(new Error("Could not authorise printer"));
        return null;
      }
      setPrinter(retrievedPrinter);
      return retrievedPrinter;
    } catch (e) {
      setError(e);
    }
    return null;
  };

  const print = async (func: (printer: Printer) => Promise<void>) => {
    const retrievedPrinter = await getOrAuthorisePrinter();
    if (retrievedPrinter) {
      try {
        await func(retrievedPrinter);
      } catch (e) {
        setError(e);
      }
    }
  };

  const reset = () => {
    setError(null);
  };

  const havePrinter = async () => {
    let hasPrinter = false;
    try {
      hasPrinter = await havePreviousPrinter();
    } catch (e) {
      setError(e);
    }

    return hasPrinter;
  };

  return { print, havePrinter, reset, error };
};

export default useThermalPrinter;
